import { Fragment } from "react";
import { useEffect, useState } from "react";
import FileSaver from "file-saver";
import { toast } from "react-toastify";
import ButtonGroup from "../../../components/ButtonGroup";
import InputGroup from "../../../components/InputGroup";
import InputGroupDate from "../../../components/InputGroupDate";
import InputFormPlain from "../../../components/InputFormPlain";
import Button from "../../../components/Button";
import Pagination from "../../../components/Pagination";
import ConsumerTableItem from "./ConsumerTableItem";
import Report from "../../../services/Report";
import { Toast } from "../../../config/Toast";

const ConsumerTable = () => {
  const [data, setData] = useState([]);
  const [update, setUpdate] = useState(false);
  const [btnFilterLoading, setBtnFilterLoading] = useState(false);
  const [btnExcelLoading, setBtnExcelLoading] = useState(false);
  const [btnInvoiceLoading, setBtnInvoiceLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [totalPage, setTotalPage] = useState(0);
  const [projects, setProjects] = useState(null);
  const [invoice, setInvoice] = useState(null);

  const notifySuccess = (message) => toast.success(message, Toast);
  const notifyFailed = (message) => toast.error(message, Toast);
  const limit = 5;

  useEffect(() => {
    if (startDate && endDate) {
      Report.consumer(pageNumber, limit, search, startDate, endDate)
        .then((res) => {
          setData(res.data.data);
          setTotalPage(res.data.total_page);
        })
        .catch((err) => {
          console.log(err);
        });

      setUpdate(false);
      setBtnFilterLoading(false);
    }
  }, [update, startDate, endDate, pageNumber, limit, search]);

  const filterHandler = () => {
    if (startDate === null || endDate === null) {
      notifyFailed("Date is required");
      return;
    }

    setBtnFilterLoading(true);
    setUpdate(true);
  };

  const excelHandler = () => {
    if (startDate === null || endDate === null) {
      notifyFailed("Date is required");
      return;
    }

    setBtnExcelLoading(true);

    Report.consumerExcel(startDate, endDate)
      .then((res) => {
        const url = `${process.env.REACT_APP_API_DOMAIN}/${res.data.path}`;
        FileSaver.saveAs(url, res.data.path);

        notifySuccess("Success download report deposit");
        setBtnExcelLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setBtnExcelLoading(false);
        notifyFailed("Something went wrong!");
      });
  };

  const searchHandler = (value) => {
    setSearch(value);
    setPageNumber(1);
    setUpdate(true);
  };

  const changePageHandler = ({ selected }) => {
    setPageNumber(selected + 1);
    setUpdate(true);
  };

  const generateInvoiceMultipleHandler = () => {
    if (projects === null || invoice === null) {
      notifyFailed("Project ID atau No invoice tidak boleh kosong");
      return;
    }

    setBtnInvoiceLoading(true);

    const projectArr = projects.replace(/\s/g, "").split(",");
    const payload = {
      projects: projectArr,
      no_invoice: invoice,
    };

    Report.consumerMultipleInvoice(payload)
      .then((res) => {
        const url = `${process.env.REACT_APP_API_DOMAIN}/${res.data.path}`;
        FileSaver.saveAs(url, res.data.path);

        notifySuccess("Success download invoice");
        setBtnInvoiceLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setBtnInvoiceLoading(false);
        notifyFailed("Something went wrong!");
      });
  };

  return (
    <Fragment>
      <div className="flex flex-column justify-content-center align-items-center w-full gap-4 p-0 m-0">
        <div className="flex flex-row justify-content-center align-items-end w-100 gap-4 p-0 m-0">
          <div className="flex flex-row justify-content-center align-items-center w-100 gap-4">
            <div className="w-100">
              <InputGroupDate type="startDate" label="Start Date" setStartDate={setStartDate} />
            </div>
            <div className="w-100">
              <InputGroupDate type="endDate" label="End Date" setEndDate={setEndDate} />
            </div>
          </div>
          <div className="flex flex-row justify-content-center align-items-center w-100">
            <div className="w-100">
              <ButtonGroup
                buttonOne="btn-primary"
                titleOne="Filter"
                iconOne="fa fa-filter me-1"
                onClickOne={filterHandler}
                loadingOne={btnFilterLoading}
                buttonTwo="btn-success"
                titleTwo="Excel"
                iconTwo="fa fa-file-excel-o me-1"
                onClickTwo={excelHandler}
                loadingTwo={btnExcelLoading}
              />
            </div>
            <div className="w-100">
              <InputGroup button="btn-dark" icon="fa fa-search" searchHandler={searchHandler} />
            </div>
          </div>
        </div>

        <div className="flex flex-row justify-content-between align-items-center w-100 gap-4">
          <div className="w-100">
            <InputFormPlain placeholder="List Project ID" changeHandler={(e) => setProjects(e)} />
          </div>
          <div className="w-100">
            <InputFormPlain placeholder="No Invoice" changeHandler={(e) => setInvoice(e)} />
          </div>
          <div className="w-100">
            <Button
              icon="fa fa-file-pdf-o me-2"
              title="Generate Invoice"
              button="btn-danger w-100"
              onClick={generateInvoiceMultipleHandler}
              loading={btnInvoiceLoading}
            />
          </div>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <div className="table-responsive">
            <table className="table table-bordered table-hover text-nowrap text-md-nowrap mb-0 text-center">
              <thead>
                <tr>
                  <th>#</th>
                  <th>No</th>
                  <th>Project ID</th>
                  <th>Project Type</th>
                  <th>Client Name</th>
                  <th>Deposit Date</th>
                  <th>Start Date</th>
                  <th>Deposit</th>
                  <th>Payment Method</th>
                  <th>Payment Channel</th>
                  <th>Fee Transfer</th>
                </tr>
              </thead>
              <tbody>
                {data.map((d, index) => (
                  <ConsumerTableItem
                    key={d.id}
                    id={d.id}
                    no={index + (pageNumber === 1 ? 1 : limit * pageNumber - limit + 1)}
                    data={d}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col">{totalPage > 0 && <Pagination pageCount={totalPage} changePage={changePageHandler} />}</div>
      </div>
    </Fragment>
  );
};

export default ConsumerTable;
